import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={12} cy={12} r={12} fill="#000" fillOpacity={0.1} />
      <Path
        d="M13.1 12l4.672-4.673a.777.777 0 10-1.1-1.099L12 10.901 7.327 6.228a.777.777 0 10-1.099 1.1L10.901 12l-4.673 4.673a.776.776 0 101.1 1.099L12 13.099l4.673 4.673a.776.776 0 001.099 0 .777.777 0 000-1.1L13.099 12z"
        fill="#000"
        fillOpacity={0.8}
        opacity={0.7}
      />
    </Svg>
  );
}

export default SvgComponent;
